(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"] && !Shopify.designMode) return;
  try {
    
(() => {
  const duplicateUpdates = cart => {
    const groups = new Map(), updates = {};
    for (const item of cart.items || []) {
      const properties = (Array.isArray(item.properties) ? item.properties : Object.entries(item.properties || {})).filter(([key]) => !['_nova_bundle_operation','_nova_bundle_source'].includes(key)).sort(([a],[b]) => a.localeCompare(b));
      const key = JSON.stringify([String(item.variant_id || item.id), item.selling_plan_allocation?.selling_plan?.id || item.sellingPlan || 0, properties]);
      if (!groups.has(key)) groups.set(key, []);
      groups.get(key).push(item);
    }
    for (const lines of groups.values()) {
      if (lines.length < 2) continue;
      const primary = lines.find(item => !item.properties?._nova_bundle_operation && !item.properties?._nova_bundle_source) || lines[0];
      updates[primary.key] = lines.reduce((sum,item) => sum + item.quantity, 0);
      for (const item of lines) if (item !== primary) updates[item.key] = 0;
    }
    return updates;
  };
  const setup = () => {
    const drawer = document.querySelector('#cart-drawer.nc-drawer');
    if (!drawer || drawer.dataset.ncReady) return;
    drawer.dataset.ncReady = 'true';
    const cfg = JSON.parse(drawer.querySelector('[data-nc-config]').textContent);
    const root = cfg.root.endsWith('/') ? cfg.root : cfg.root + '/';
    const t = (key, values = {}) => Object.entries(values).reduce((text, [name, value]) => text.replaceAll(`{${name}}`, value), cfg.labels[key] || key);
    const status = drawer.querySelector('[data-nc-status]');
    const items = drawer.querySelector('[data-items-holder]');
    let busy = false, blocked = false, scheduled = false, statusTimer,autoGiftSignature;
    const state = () => { try { return JSON.parse(items.querySelector('[data-nc-state]')?.textContent || '{"items":[],"count":0}'); } catch { return {items:[],count:0}; } };
    const count = cart => cart.items.filter(i => i.eligible && !i.gift).reduce((n,i) => n+i.quantity,0);
    const giftCount = cart => cart.items.filter(i => i.giftEligible && !i.gift).reduce((n,i) => n+i.quantity,0);
    const giftSignature = cart => cart.items.filter(i=>!i.gift).map(i=>`${i.id}:${i.quantity}:${i.key}`).join('|');
    const announce = (text, persistent = false) => { clearTimeout(statusTimer); status.textContent = text; if(!persistent) statusTimer = setTimeout(() => status.textContent = '',6000); };
    const lock = on => { drawer.querySelectorAll('button,input,select').forEach(el => { if(!el.matches('[data-cart-drawer-close]')) el.disabled = on; }); drawer.setAttribute('aria-busy',String(on)); };
    const request = async (path, body) => {
      const response = await fetch(root + path,{method:body?'POST':'GET',credentials:'same-origin',headers:{Accept:'application/json',...(body?{'Content-Type':'application/json'}:{})},...(body?{body:JSON.stringify(body)}:{})});
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || data.message || t('add_error'));
      return data;
    };
    const sectionBody = body => ({...body,sections:['api-cart-items'],sections_url:root+'cart'});
    const render = async (data = {}) => {
      let html = data.sections?.['api-cart-items'];
      if(!html){const response=await fetch(root+'cart?section_id=api-cart-items',{credentials:'same-origin'});if(!response.ok)throw Error(t('retry'));html=await response.text();}
      const fragment = new DOMParser().parseFromString(html,'text/html').querySelector('[data-api-content]');
      if(!fragment || typeof items.build !== 'function') throw Error(t('retry'));
      items.build(fragment);
      document.dispatchEvent(new CustomEvent('nova:cart:updated'));
      schedule();
    };
    window.NovaCart = {ready:Promise.resolve(),open:async(data,notice='') => {await render(data);await window.NovaCart.ready;drawer.dispatchEvent(new CustomEvent('theme:cart-drawer:show'));if(notice)announce(notice,true);}};

    async function combineMatchingLines() {
      busy = true; lock(true);
      let complete = false;
      try {
        const fresh = await request('cart.js');
        const updates = duplicateUpdates(fresh);
        if (Object.keys(updates).length) await render(await request('cart/update.js', sectionBody({updates})));
        else await render();
        complete = true;
      } catch {
        announce(t('retry'), true);
      } finally { busy = false; lock(blocked); if (complete) schedule(); }
    }


    let relatedSignature = '', relatedRequest = 0;
    const relatedCache = new Map();
    async function refreshRelated(cart) {
      const modules = Array.from(drawer.querySelectorAll('[data-nc-related]'));
      if (!modules.length) return;
      // Suggestions mirror the Related products section of the product being viewed, or of the first
      // product in the cart: its hand-picked list, otherwise Shopify's related picks. No section, no suggestions.
      const pageRelated = document.querySelector('related-products [data-related-section]');
      const sourceItem = cart.items.find(item => !item.gift);
      const sourceHandle = pageRelated ? '' : (modules[0].dataset.pageHandle || sourceItem?.handle || '');
      const signature = JSON.stringify([pageRelated?.getAttribute('data-product-id') || sourceHandle, cart.items.map(item => String(item.product))]);
      if (signature === relatedSignature) return;
      relatedSignature = signature;
      const requestId = ++relatedRequest;
      modules.forEach(module => {
        module.hidden = true;
        module.querySelector('[data-nc-slides]').replaceChildren();
      });
      const fetchHtml = async (url, selector) => {
        const cacheKey = url.href + selector;
        if (relatedCache.has(cacheKey)) return relatedCache.get(cacheKey);
        const response = await fetch(url, {credentials: 'same-origin'});
        if (!response.ok) throw new Error('Related products unavailable');
        const found = new DOMParser().parseFromString(await response.text(), 'text/html').querySelector(selector);
        const html = found ? (selector === '[data-related-section]' ? found.outerHTML : found.innerHTML) : '';
        relatedCache.set(cacheKey, html);
        return html;
      };
      let section = pageRelated;
      if (!section && sourceHandle) {
        try {
          const html = await fetchHtml(new URL(root + 'products/' + encodeURIComponent(sourceHandle) + '?section_id=related', window.location.origin), '[data-related-section]');
          section = html ? new DOMParser().parseFromString(html, 'text/html').querySelector('[data-related-section]') : null;
        } catch {}
      }
      if (requestId !== relatedRequest || !section) return;
      const limit = Math.max(1, Math.min(10, Number(section.getAttribute('data-limit')) || 4));
      const urls = section.hasAttribute('data-related-manual')
        ? (section.getAttribute('data-related-handles') || '').split(',').filter(Boolean).map(handle => new URL(root + 'products/' + encodeURIComponent(handle) + '?section_id=api-nova-cart-related', window.location.origin))
        : [Object.assign(new URL(root + 'recommendations/products', window.location.origin), {search: new URLSearchParams({section_id: 'api-nova-cart-related', product_id: section.getAttribute('data-product-id'), limit: String(limit), intent: 'related'})})];
      const results = await Promise.all(urls.map(async url => {
        try {
          return await fetchHtml(url, '[data-nc-related-results]');
        } catch {
          if (requestId === relatedRequest) relatedSignature = '';
          return '';
        }
      }));
      if (requestId !== relatedRequest || !drawer.isConnected) return;
      const inCart = new Set(state().items.map(item => String(item.product)));
      modules.forEach(module => {
        const list = module.querySelector('[data-nc-slides]');
        const seen = new Set(inCart);
        const fragment = document.createDocumentFragment();
        results.forEach(html => {
          const parsed = new DOMParser().parseFromString(html, 'text/html');
          parsed.querySelectorAll('[data-nc-offer]').forEach(card => {
            if (seen.has(card.dataset.product)) return;
            seen.add(card.dataset.product);
            const select = card.querySelector('[data-nc-variant]');
            const label = card.querySelector('label');
            if (select) {
              select.id = list.id + '-variant-' + card.dataset.product;
              if (label) label.htmlFor = select.id;
            }
            fragment.append(card);
          });
        });
        list.replaceChildren(fragment);
        list.scrollLeft = 0;
      });
      carousels.forEach(refresh => refresh());
      if (busy || blocked) lock(true);
    }

    const carousels = [];
    drawer.querySelectorAll('[data-nc-upsells]').forEach(module => {
      const list=module.querySelector('[data-nc-slides]');
      if(!list)return;
      let timer,hovered=false;
      const cards=()=>Array.from(list.querySelectorAll('[data-nc-offer]')).filter(el=>!el.hidden);
      const current=()=>{const all=cards(),edge=list.getBoundingClientRect().left;let index=0,distance=Infinity;all.forEach((el,i)=>{const delta=Math.abs(el.getBoundingClientRect().left-edge);if(delta<distance){distance=delta;index=i;}});return index;};
      const sync=()=>{module.hidden=cards().length===0;};
      const move=direction=>{const all=cards();if(all.length<2)return;const target=all[(current()+direction+all.length)%all.length];list.scrollTo({left:list.scrollLeft+target.getBoundingClientRect().left-list.getBoundingClientRect().left,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});};
      const scheduleSlide=()=>{clearTimeout(timer);if(module.dataset.autoplay!=='true'||hovered||busy||blocked||document.hidden||!drawer.classList.contains('is-open')||module.contains(document.activeElement)||cards().length<2||matchMedia('(prefers-reduced-motion: reduce)').matches)return;timer=setTimeout(()=>{move(1);scheduleSlide();},Number(module.dataset.seconds||5)*1000);};
      module.addEventListener('pointerenter',()=>{hovered=true;clearTimeout(timer);});module.addEventListener('pointerleave',()=>{hovered=false;scheduleSlide();});
      module.addEventListener('focusin',()=>clearTimeout(timer));module.addEventListener('focusout',()=>setTimeout(scheduleSlide,0));module.addEventListener('touchstart',()=>clearTimeout(timer),{passive:true});
      document.addEventListener('visibilitychange',scheduleSlide);
      carousels.push(()=>{sync();scheduleSlide();});
    });
    new MutationObserver(()=>{carousels.forEach(refresh=>refresh());schedule();}).observe(drawer,{attributes:true,attributeFilter:['class']});
    function eligibleGift(module, cart) { return giftCount(cart)>=Number(module.dataset.minimum); }
    function schedule(){if(scheduled)return;scheduled=true;queueMicrotask(()=>{scheduled=false;update();});}
    function update(){
      const rows=Array.from(items.querySelectorAll(':scope > [data-item]'));
      const ordered=rows.slice().sort((a,b)=>Number(b.dataset.itemIndex)-Number(a.dataset.itemIndex));
      if(rows.some((row,i)=>row!==ordered[i]))ordered.forEach(row=>items.append(row));
      const cart=state(),n=count(cart),gift=cart.items.find(i=>i.gift);
      if (!busy && !blocked && !drawer.classList.contains('is-loading') && Object.keys(duplicateUpdates(cart)).length) {
        window.NovaCart.ready = combineMatchingLines();
        return;
      }
      drawer.querySelectorAll('[data-nc-progress]').forEach(module=>{
        const next=n<cfg.one?{qty:cfg.one,pct:cfg.percentOne}:n<cfg.two?{qty:cfg.two,pct:cfg.percentTwo}:null;
        module.querySelector('[data-nc-progress-copy]').textContent=next?t('next_tier',{count:next.qty-n,percent:next.pct}):t('top_tier',{percent:cfg.percentTwo});
        module.querySelector('[data-nc-meter]').value=Math.min(n,cfg.two);
      });
      void refreshRelated(cart);
      drawer.querySelectorAll('[data-nc-upsells] [data-nc-offer]').forEach(offer=>{offer.hidden=cart.items.some(i=>i.product===Number(offer.dataset.product));});
      drawer.querySelectorAll('[data-nc-gift]').forEach(module=>{
        const valid=eligibleGift(module,cart),conflict=false;
        module.querySelector('[data-nc-gift-copy]').textContent=gift&&gift.price===0?t('gift_added'):conflict?t('gift_bundle'):valid?t('gift_ready'):t('gift_locked',{count:Math.max(0,Number(module.dataset.minimum)-giftCount(cart))});
        module.querySelectorAll('[data-nc-add]').forEach(button=>{button.disabled=busy||blocked||!valid||Boolean(gift);});
        drawer.dataset.ncGiftAuto=module.dataset.automatic;
        if(!giftCount(cart))autoGiftSignature=undefined;
        if(gift&&!busy&&!blocked&&!drawer.classList.contains('is-loading')&&(!valid||gift.price!==0||gift.quantity!==1||gift.id!==Number(module.querySelector('[data-nc-variant]')?.value)||cart.items.filter(i=>i.gift).length>1)) reconcileGift(module,cart);
        if(module.dataset.automatic==='true'&&valid&&!gift&&!busy&&!blocked&&!drawer.classList.contains('is-loading')){
          const signature=giftSignature(cart),button=module.querySelector('[data-nc-add]');
          if(button&&signature!==autoGiftSignature){autoGiftSignature=signature;void addAutomaticGift(button);}
        }
      });
      carousels.forEach(refresh=>refresh());
      if(busy||blocked)lock(true);
    }
    async function addAutomaticGift(button){
      const run=async()=>{
        if(busy||blocked)return;
        const fresh=await request('cart.js');
        if(fresh.items.some(i=>i.properties?._nova_cart_gift==='true')){await render();return;}
        const eligibleProducts=new Set(state().items.filter(i=>i.giftEligible).map(i=>i.product));
        if(!fresh.items.some(i=>eligibleProducts.has(i.product_id)))return;
        await addOffer(button,true);
      };
      try{if(navigator.locks)await navigator.locks.request('nova-cart-auto-gift',run);else await run();}
      catch(error){autoGiftSignature=giftSignature(state());console.warn('NovaCart automatic gift:',error);announce(t('gift_unavailable'),true);}
    }
    async function reconcileGift(module,cart){
      busy=true;lock(true);
      try{
        for(const gift of cart.items.filter(i=>i.gift)){
          const data=await request('cart/change.js',sectionBody({id:gift.key,quantity:0}));await render(data);
        }
        autoGiftSignature=undefined;announce(t('gift_removed'));
      }catch{blocked=true;announce(t('retry'),true);}finally{busy=false;lock(blocked);update();}
    }
    drawer.addEventListener('change',event=>{
      const select=event.target.closest('[data-nc-variant]');if(!select)return;
      const offer=select.closest('[data-nc-offer]'),option=select.selectedOptions[0],img=offer.querySelector('img');
      if(img&&option.dataset.image){img.removeAttribute('srcset');img.src=option.dataset.image;}
      if(offer.dataset.gift!=='true')offer.querySelector('[data-nc-offer-price]').textContent=option.dataset.price;
    });
    drawer.querySelector('[data-discount-input]')?.addEventListener('keydown',event=>{
      if(event.key==='Enter'){event.preventDefault();drawer.querySelector('[data-apply-discount]')?.click();}
    });
    drawer.addEventListener('click',event=>{
      const button=event.target.closest('[data-nc-add]');if(!button)return;
      event.preventDefault();void addOffer(button);
    });
    async function addOffer(button,automatic=false){
      if(busy||blocked||drawer.classList.contains('is-loading'))return;
      const offer=button.closest('[data-nc-offer]'),isGift=offer.dataset.gift==='true',module=offer.closest('[data-nc-gift]');
      const select=offer.querySelector('[data-nc-variant]'),id=Number(select?.value);if(!id)return;
      if(isGift&&(!eligibleGift(module,state())||state().items.some(i=>i.gift)))return;
      busy=true;lock(true);announce(t('updating'),true);
      const operation=crypto.randomUUID();let added=false;
      try{
        const properties=isGift?{_nova_cart_gift:'true',_nova_gift_operation:operation,...(module.dataset.backend==='opus'?{__cd_opus_free_gift:module.dataset.offerKey,__opus_discount:JSON.stringify({id:module.dataset.offerKey.replace(/^freeGift_/, '')})}:{})}:{};
        let data=await request('cart/add.js',sectionBody({items:[{id,quantity:1,properties}]}));added=true;
        if(isGift){
          let cart=await request('cart.js');
          const code=module.dataset.discountCode?.trim();
          if(code){const codes=[...new Set([...(cart.discount_codes||[]).map(d=>d.code),code])];cart=await request('cart/update.js',sectionBody({discount:codes.join(',')}));data=cart;}
          const gift=cart.items.find(i=>i.properties?._nova_gift_operation===operation);
          if(!gift||gift.final_line_price!==0){if(gift)data=await request('cart/change.js',sectionBody({id:gift.key,quantity:0}));await render(data);announce(t('gift_unavailable'),true);return;}
        }
        await render(data);announce(t(isGift?'gift_added':'added'));
      }catch(error){
        if(isGift){
          try{const cart=await request('cart.js');const gift=cart.items.find(i=>i.properties?._nova_gift_operation===operation);if(gift){const data=await request('cart/change.js',sectionBody({id:gift.key,quantity:0}));await render(data);}}
          catch{blocked=true;}
        }else if(added){try{await render();}catch{blocked=true;}}
        announce(blocked?t('retry'):error.message,true);
      }finally{if(automatic)autoGiftSignature=giftSignature(state());busy=false;lock(blocked);update();}
    }
    drawer.querySelector('[data-cart-form]')?.addEventListener('submit',event=>{
      const module=drawer.querySelector('[data-nc-gift]'),cart=state();
      if(busy||blocked||(module&&cart.items.some(i=>i.gift)&&(!eligibleGift(module,cart)||cart.items.some(i=>i.gift&&(i.price!==0||i.quantity!==1))))){event.preventDefault();event.stopImmediatePropagation();update();}
    },true);
    new MutationObserver(schedule).observe(items,{childList:true,subtree:true});
    document.addEventListener('theme:cart:change',schedule);
    document.addEventListener('theme:cart-drawer:open',schedule);
    document.addEventListener('shopify:section:load',schedule);
    update();
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',setup,{once:true});else setup();
  document.addEventListener('shopify:section:load',setup);
  document.addEventListener('click',event=>{
    const edit=event.target.closest('[data-nova-marathon-edit]');
    if(!edit)return;
    const d=edit.dataset;
    try{sessionStorage.setItem('nova-marathon-cart-edit',JSON.stringify({key:d.editKey,quantity:Number(d.editQuantity),route:d.editRoute,event:d.editEvent,start:d.editStart,style:d.editStyle,size:d.editSize,name:d.editName,bib:d.editBib,date:d.editDate,time:d.editTime,pace:d.editPace,unit:d.editUnit}));}
    catch(error){event.preventDefault();window.alert('Editing is unavailable in this browser. Your cart is unchanged.');}
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nova-bundle-builder"] && !Shopify.designMode) return;
  try {
    
const NovaBundleCore = Object.freeze({
  tier(quantity, tiers) {
    return tiers.filter(t => quantity >= t.quantity).sort((a, b) => b.percent - a.percent)[0] || {quantity: 0, percent: 0};
  },
  totals(lines, tiers) {
    const quantity = lines.reduce((n, line) => n + line.quantity, 0);
    const subtotal = lines.reduce((n, line) => n + line.price * line.quantity, 0);
    const percent = this.tier(quantity, tiers).percent;
    const savings = lines.reduce((n, line) => n + Math.floor(line.price * line.quantity * percent / 100), 0);
    return {quantity, subtotal, percent, savings, total: subtotal - savings};
  },
  key(id, properties = {}) {
    return JSON.stringify([String(id), Object.entries(properties).filter(([key]) => !['_nova_bundle_operation', '_nova_bundle_source'].includes(key)).sort(([a], [b]) => a.localeCompare(b))]);
  },
  cartLines(snapshot, catalogs) {
    const eligible = new Set(snapshot.memberships.filter(m => !catalogs.size || m.collections.some(id => catalogs.has(Number(id)))).map(m => Number(m.product)));
    const lines = new Map();
    for (const item of snapshot.cart.items || []) {
      if (!eligible.has(Number(item.product_id)) || item.properties?._nova_cart_gift === 'true' || item.selling_plan_allocation) continue;
      const properties = Object.fromEntries(Object.entries(item.properties || {}).filter(([key]) => !['_nova_bundle_operation', '_nova_bundle_source'].includes(key)));
      const key = this.key(item.variant_id, properties);
      let line = lines.get(key);
      if (!line) {
        line = {id: Number(item.variant_id), handle: item.handle, productId: Number(item.product_id), title: item.product_title || item.title, variant: item.variant_title || '', optionValues: (item.options_with_values || []).map(o => o.value), price: item.original_price ?? item.price, image: item.featured_image?.url || item.image, properties, quantity: 0, cartLines: []};
        lines.set(key, line);
      }
      line.quantity += item.quantity;
      line.cartLines.push({key: item.key, quantity: item.quantity, properties: {...(item.properties || {})}, fromBuilder: Boolean(item.properties?._nova_bundle_operation || item.properties?._nova_bundle_source)});
    }
    return lines;
  },
  changes(lines, base) {
    const changes = new Map();
    for (const key of new Set([...lines.keys(), ...base.keys()])) {
      const quantity = (lines.get(key)?.quantity || 0) - (base.get(key)?.quantity || 0);
      if (quantity) changes.set(key, {...(lines.get(key) || base.get(key)), quantity});
    }
    return changes;
  },
  merge(base, changes) {
    const lines = new Map([...base].map(([key, line]) => [key, {...line}]));
    for (const [key, change] of changes) {
      const quantity = Math.max(0, (base.get(key)?.quantity || 0) + change.quantity);
      if (quantity) lines.set(key, {...(base.get(key) || change), quantity});
      else lines.delete(key);
    }
    return lines;
  },
  plan(lines, base) {
    const additions = [], updates = {};
    for (const [key, change] of this.changes(lines, base)) {
      if (change.quantity > 0) {
        const existing = base.get(key)?.cartLines?.[0];
        additions.push({id: change.id, quantity: change.quantity, properties: {...(existing?.properties || change.properties)}});
      }
      else {
        let remove = -change.quantity;
        const existing = [...(base.get(key)?.cartLines || [])].sort((a,b) => Number(b.fromBuilder) - Number(a.fromBuilder));
        for (const line of existing) {
          const take = Math.min(remove, line.quantity);
          if (take) updates[line.key] = line.quantity - take;
          remove -= take;
        }
      }
    }
    return {additions, updates};
  },
  normalize(text) {
    return String(text || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
  },
  codes(existing, added) {
    const values = [...existing, ...String(added || '').split(',')].map(s => String(s).trim()).filter(Boolean);
    return values.filter((s, i) => values.findIndex(t => t.toLowerCase() === s.toLowerCase()) === i);
  },
  reconcileTargets(cart, targets) {
    const actual = new Map();
    for (const item of cart.items || []) {
      const key = this.key(item.variant_id, item.properties || {});
      actual.set(key, (actual.get(key) || 0) + item.quantity);
    }
    return targets.every(line => (actual.get(this.key(line.id, line.properties)) || 0) >= line.quantity) ? 'complete' : 'partial';
  },
  reconcile(cart, operation, lines) {
    const actual = new Map();
    for (const item of cart.items || []) {
      if (item.properties?._nova_bundle_operation !== operation) continue;
      const props = {...item.properties};
      delete props._nova_bundle_operation;
      const key = this.key(item.variant_id, props);
      actual.set(key, (actual.get(key) || 0) + item.quantity);
    }
    if (!actual.size) return 'none';
    const expected = new Map(lines.map(l => [this.key(l.id, l.properties), l.quantity]));
    return actual.size === expected.size && [...expected].every(([key, n]) => actual.get(key) === n) ? 'complete' : 'partial';
  }
});

(() => {
  if (customElements.get('nova-bundle-builder')) return;
  class NovaBundleBuilder extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.cfg = JSON.parse(this.querySelector('[data-nb-config]').textContent);
      this.root = this.cfg.root;
      this.lines = new Map();
      this.base = new Map();
      this.synced = false;
      this.cache = new Map();
      this.life = new AbortController();
      this.activeCollectionId = this.cfg.collectionId;
      this.collectionLinks = [...this.querySelectorAll('[data-nb-collection]')];
      this.activeCollectionURL = this.collectionLinks[0]?.href;
      this.storageKey = `nova-bundle:v2:${this.cfg.section}:${this.cfg.currency}:${this.cfg.collectionId}:${this.collectionLinks.map(link => link.dataset.nbCollection).join('-')}`;
      this.grid = this.querySelector('[data-nb-grid]');
      this.next = this.querySelector('[data-nb-next]');


      this.picker = this.querySelector('[data-nb-picker]');
      this.picker.addEventListener('close', () => this.restorePicker(), {signal: this.life.signal});
      this.picker.addEventListener('click', event => {
        if (event.target !== this.picker) return;
        const rect = this.picker.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.closePicker();
      }, {signal: this.life.signal});
      this.bar = this.querySelector('[data-nb-bar]');
      this.tiers = this.cfg.tiers.slice().sort((a, b) => a.quantity - b.quantity);
      this.addEventListener('click', e => this.click(e), {signal: this.life.signal});
      this.addEventListener('change', e => this.change(e), {signal: this.life.signal});
      this.addEventListener('submit', e => this.submit(e), {signal: this.life.signal});
      this.querySelector('[data-nb-search]').addEventListener('input', () => {
        clearTimeout(this.searchTimer);
        this.searchTimer = setTimeout(() => this.search(), 260);
      }, {signal: this.life.signal});
      this.resize = new ResizeObserver(() => this.style.setProperty('--nb-bar-height', `${this.bar.offsetHeight}px`));
      this.resize.observe(this.bar);
      this.catalogs = new Set(this.collectionLinks.map(link => Number(link.dataset.nbCollection)).filter(Boolean));
      let drafts = new Map();
      try {
        const saved = JSON.parse(sessionStorage.getItem(this.storageKey));
        if (saved?.time > Date.now() - 86400000 && Array.isArray(saved.changes)) {
          drafts = new Map(saved.changes.filter(l => Number.isSafeInteger(l.id) && Number.isInteger(l.quantity) && l.quantity !== 0).slice(0,100).map(l => [NovaBundleCore.key(l.id, l.properties), l]));
          this.pending = saved.pending;
        }
      } catch {}
      if (this.cfg.cartState) this.applyCart(this.cfg.cartState, drafts);
      const refresh = () => {
        clearTimeout(this.cartTimer);
        this.cartTimer = setTimeout(() => { if (!this.busy && !document.hidden) this.refreshCart().catch(() => this.message(this.t('load_error'), true)); }, 120);
      };
      document.addEventListener('theme:cart:change', refresh, {signal: this.life.signal});
      document.addEventListener('nova:cart:updated', refresh, {signal: this.life.signal});
      document.addEventListener('visibilitychange', refresh, {signal: this.life.signal});
      window.addEventListener('pageshow', refresh, {signal: this.life.signal});
      window.addEventListener('focus', refresh, {signal: this.life.signal});
      refresh();
      this.initCards();
      this.querySelector('[data-nb-controls]').hidden = false;
      this.next.hidden = !this.next.getAttribute('href');
      this.draw();
      if (this.pending) this.message(this.t('uncertain'), true);
    }
    disconnectedCallback() {
      this.closePicker();
      this.life?.abort();
      this.searchAbort?.abort();
      this.productAbort?.abort();
      this.resize?.disconnect();
      clearTimeout(this.searchTimer);
      clearTimeout(this.cartTimer);
      this.initialized = false;
    }
    t(key, values = {}) {
      let text = this.cfg.strings[key] || key;
      for (const [name, value] of Object.entries(values)) text = text.replaceAll(`{${name}}`, String(value));
      return text;
    }
    money(cents) {
      return new Intl.NumberFormat(this.cfg.locale, {style: 'currency', currency: this.cfg.currency}).format(cents / 100);
    }
    el(tag, text, className) {
      const el = document.createElement(tag);
      if (text !== undefined) el.textContent = text;
      if (className) el.className = className;
      return el;
    }
    button(text, action, label) {
      const button = this.el('button', text, 'nb-button');
      button.type = 'button';
      button.dataset.nbAction = action;
      if (label) button.setAttribute('aria-label', label);
      return button;
    }
    image(src, alt, size = 160) {
      const img = this.el('img');
      if (src) {
        const url = new URL(src, location.origin);
        if (url.protocol === 'https:' || url.origin === location.origin) {
          url.searchParams.set('width', String(size));
          img.src = url.href;
        }
      }
      img.alt = alt;
      img.width = size;
      img.height = size;
      img.loading = 'lazy';
      img.decoding = 'async';
      return img;
    }
    save() {
      const changes = [...NovaBundleCore.changes(this.lines, this.base).values()];
      try { sessionStorage.setItem(this.storageKey, JSON.stringify({changes, pending: this.pending, time: Date.now()})); } catch {}
    }
    applyCart(snapshot, changes = NovaBundleCore.changes(this.lines, this.base)) {
      this.snapshot = snapshot;
      this.base = NovaBundleCore.cartLines(snapshot, this.catalogs);
      this.lines = NovaBundleCore.merge(this.base, changes);
      this.synced = true;
      if (snapshot.cart.currency) this.cfg.currency = snapshot.cart.currency;
    }
    async cartSnapshot() {
      if (window.NovaCart?.ready) await window.NovaCart.ready;
      if (this.cfg.preview) return {cart: await window.NovaBundlePreview.cart(), memberships: this.cfg.cartState?.memberships || []};
      const response = await fetch(`${this.root}cart?section_id=nova-bundle-cart`, {credentials: 'same-origin', cache: 'no-store', signal: AbortSignal.timeout(20000)});
      if (!response.ok) throw new Error(this.t('network_error'));
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const snapshot = JSON.parse(doc.querySelector('[data-nb-cart]')?.textContent || 'null');
      if (!snapshot?.cart?.items || !snapshot.memberships) throw new Error(this.t('network_error'));
      return snapshot;
    }
    cartFromSections(data) {
      const html = data?.sections?.['nova-bundle-cart'];
      if (!html) return null;
      try {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const snapshot = JSON.parse(doc.querySelector('[data-nb-cart]')?.textContent || 'null');
        return snapshot?.cart?.items && snapshot.memberships ? snapshot : null;
      } catch { return null; }
    }
    async refreshCart() {
      if (this.refreshing) return this.refreshing;
      this.refreshing = (async () => {
        const snapshot = await this.cartSnapshot();
        if (this.pending?.targets) {
          this.applyCart(snapshot, new Map());
          for (const target of this.pending.targets) {
            const key = NovaBundleCore.key(target.id, target.properties);
            this.lines.set(key, {...target, quantity: Math.max(target.quantity, this.base.get(key)?.quantity || 0)});
          }
          if ((this.pending.mode === 'quantity' ? NovaBundleCore.reconcileTargets(snapshot.cart, this.pending.targets) : NovaBundleCore.reconcile(snapshot.cart, this.pending.operation, this.pending.items)) === 'complete') this.pending = null;
        } else this.applyCart(snapshot);
        this.draw();
        return snapshot;
      })();
      try { return await this.refreshing; } finally { this.refreshing = null; }
    }
    selectionSignature() {
      return JSON.stringify([...this.lines].map(([key, line]) => [key, line.quantity]).sort((a, b) => a[0].localeCompare(b[0])));
    }
    message(text, error = false) {
      this.querySelector('[data-nb-recovery]').hidden = !error && !this.pending;
      for (const output of this.querySelectorAll('[data-nb-message]')) {
        output.textContent = text;
        output.classList.toggle('nb-error', error);
        output.classList.toggle('nb-sr', !error);
      }
    }
    async click(event) {
      const choice = event.target.closest('[data-nb-choice]');
      if (choice) {
        if (this.busy) return;
        event.preventDefault();
        const form = choice.closest('[data-nb-card-form]');
        const select = form.querySelector(`[data-nb-option-index="${choice.dataset.nbIndex}"]`);
        select.value = choice.dataset.nbValue;
        select.dispatchEvent(new Event('change', {bubbles: true}));
        return;
      }
      const product = event.target.closest('[data-nb-product]');
      if (product && product.closest('.nb-card')?.querySelector('[data-nb-card-form]') && !event.ctrlKey && !event.metaKey && !event.shiftKey) {
        event.preventDefault();
        if (!this.busy) this.openPicker(product);
        return;
      }
      const target = event.target.closest('[data-nb-action]');
      if (!target || !this.contains(target)) return;
      event.preventDefault();
      if (this.busy) return;
      const action = target.dataset.nbAction;
      if (action === 'browse') { this.grid.scrollIntoView({block: 'start', behavior: 'auto'}); this.grid.querySelector('[data-nb-product]')?.focus({preventScroll: true}); }
      if (action === 'close-picker') this.closePicker();
      if (action === 'add') await this.addBundle();
      if (action === 'collection') {
        this.activeCollectionId = Number(target.dataset.nbCollection);
        this.activeCollectionURL = target.href;
        for (const link of this.collectionLinks) {
          if (link === target) link.setAttribute('aria-current', 'true');
          else link.removeAttribute('aria-current');
        }
        this.querySelector('[data-nb-search]').value = '';
        await this.search();
      }
      if (action === 'more' && target.getAttribute('aria-disabled') !== 'true') await this.loadCatalog(target.href, true);
      if (action === 'clear-search') { this.querySelector('[data-nb-search]').value = ''; await this.search(); }
      if (action === 'remove' || action === 'minus' || action === 'plus') {
        const row = target.closest('[data-nb-key]');
        const line = this.lines.get(row.dataset.nbKey);
        if (!line) return;
        if (action === 'remove' || (action === 'minus' && line.quantity === 1)) this.lines.delete(row.dataset.nbKey);
        else line.quantity = action === 'plus' ? Math.min(this.cfg.maxQuantity, line.quantity + 1) : line.quantity - 1;
        this.draw();
        const replacement = [...this.querySelectorAll('[data-nb-strip] [data-nb-key]')].find(r => r.dataset.nbKey === row.dataset.nbKey);
        (replacement?.querySelector(`[data-nb-action="${action}"]`) || this.querySelector('[data-nb-add]')).focus();
      }
      if (action === 'new') {
        await this.refreshCart();
        this.pending = null;
        this.applyCart(this.snapshot, new Map());
        this.message('');
        this.draw();
      }
    }
    change(event) {
      if (event.target.matches('[data-nb-option-index]')) {
        const form = event.target.closest('[data-nb-card-form]');
        const values = [...form.querySelectorAll('[data-nb-option-index]')].map(select => select.value);
        const variants = form.querySelector('[data-nb-variant]');
        const match = [...variants.options].find(option => JSON.parse(option.dataset.nbOptionValues || '[]').every((value, index) => value === values[index]));
        variants.value = match?.value || '';
        this.updateCard(form);
      }
      if (event.target.matches('[data-nb-variant]')) this.updateCard(event.target.closest('[data-nb-card-form]'));
    }
    async submit(event) {
      if (event.target.matches('[data-nb-search-form]')) { event.preventDefault(); await this.search(); }
      if (event.target.matches('[data-nb-card-form]')) { event.preventDefault(); this.selectProduct(event.target); }
    }
    async request(url, options = {}) {
      const response = await fetch(url, {...options, credentials: 'same-origin', headers: {'Accept': 'application/json', ...options.headers}, signal: options.signal || AbortSignal.timeout(20000)});
      let data;
      try { data = await response.json(); } catch { throw new Error(this.t('network_error')); }
      if (!response.ok) { const error = new Error(data.description || data.message || this.t('network_error')); error.status = response.status; throw error; }
      return data;
    }
    async product(handle, fresh = false) {
      const cached = this.cache.get(handle);
      if (!fresh && cached?.time > Date.now() - 60000) return cached.data;
      const data = this.cfg.preview ? await window.NovaBundlePreview.product(handle) : await this.request(`${this.root}products/${encodeURIComponent(handle)}.js`);
      this.cache.set(handle, {data, time: Date.now()});
      if (this.cache.size > 32) this.cache.delete(this.cache.keys().next().value);
      return data;
    }
    openPicker(link) {
      this.closePicker();
      this.pickerCard = link.closest('.nb-card');
      this.pickerTrigger = link;
      this.pickerForm = this.pickerCard.querySelector('[data-nb-card-form]');
      this.querySelector('[data-nb-picker-title]').textContent = link.querySelector('.nb-card-name').textContent;
      this.querySelector('[data-nb-picker-image]').replaceChildren(this.image(this.pickerCard.dataset.nbPopupImage || link.dataset.nbImage, link.querySelector('.nb-card-name').textContent, 1200));
      this.querySelector('[data-nb-picker-error]').textContent = '';
      this.querySelector('[data-nb-picker-form]').append(this.pickerForm);
      this.pickerForm.hidden = false;
      this.updateCard(this.pickerForm);
      this.picker.showModal();
    }
    closePicker() {
      if (this.picker?.open) this.picker.close();
      this.restorePicker();
    }
    restorePicker() {
      if (!this.pickerForm || this.picker?.open) return;
      this.pickerForm.hidden = true;
      this.pickerCard.append(this.pickerForm);
      this.pickerForm = null;
      this.pickerTrigger?.focus({preventScroll: true});
      this.pickerCard = null;
    }
    optionLabel(value) {
      return String(value).replace(/\s*\([^)]*\)/g, '').replace(/orignial/ig, 'Original').trim();
    }
    initCards() {
      for (const form of this.querySelectorAll('[data-nb-card-form]')) {
        if (form.dataset.nbReady) continue;
        form.dataset.nbReady = 'true';
        const card = form.closest('.nb-card');
        const tags = JSON.parse(card.dataset.nbTags || '[]');
        const variants = form.querySelector('[data-nb-variant]');
        const names = JSON.parse(form.dataset.nbOptions || '[]');
        const selected = JSON.parse(variants.selectedOptions[0]?.dataset.nbOptionValues || '[]');
        if (variants.options.length > 1 || variants.options[0]?.textContent.trim() !== 'Default Title') {
          const groups = this.el('div', undefined, 'nb-picker-options');
          names.forEach((name, index) => {
            const label = this.el('fieldset', undefined, 'nb-option-group');
            label.dataset.nbGroupIndex = String(index);
            label.append(this.el('legend', name));
            const choices = this.el('div', undefined, 'nb-option-choices');
            const select = this.el('select');
            select.dataset.nbOptionIndex = String(index);
            select.hidden = true;
            select.setAttribute('aria-label', name);
            for (const value of new Set([...variants.options].map(option => JSON.parse(option.dataset.nbOptionValues || '[]')[index]))) {
              if (value == null) continue;
              const option = this.el('option', this.optionLabel(value));
              option.value = value; option.selected = value === selected[index]; select.append(option);
              const button = this.el('button', undefined, 'nb-option-tile');
              button.type = 'button'; button.dataset.nbChoice = ''; button.dataset.nbIndex = String(index); button.dataset.nbValue = value;
              button.setAttribute('aria-label', this.optionLabel(value)); button.title = this.optionLabel(value);
              button.append(this.el('strong', this.optionLabel(value)));
              if (!/size|taille|dimension|gr[öo]sse/i.test(name)) {
                button.classList.add('nb-style-swatch');
                const color = this.optionLabel(value).toLowerCase();
                if (/^(black|white|red|green|blue|yellow|orange|purple|pink|brown|gray|grey|beige|navy|teal|gold|silver)$/.test(color)) {
                  button.style.setProperty('--nb-swatch', color === 'green' ? '#327c57' : color === 'black' ? '#282c2c' : color);
                  button.classList.add('nb-color-swatch');
                }
              }
              choices.append(button);
            }
            label.append(select, choices); groups.append(label);
          });
          form.prepend(groups);
        }
        const props = form.querySelector('[data-nb-card-properties]');
        for (const field of this.cfg.fields) {
          if (field.tag && !tags.includes(field.tag)) continue;
          const group = this.el('label', `${field.label}${field.required ? ' *' : ''}`, 'nb-field');
          const input = this.el('input');
          input.type = 'text'; input.name = field.key;
          input.required = field.required; input.maxLength = field.maxLength;
          if (field.pattern) input.pattern = field.pattern;
          input.placeholder = field.placeholder || '';
          group.append(input); props.append(group);
        }
        form.querySelector('[data-nb-card-add]').hidden = false;
        this.updateCard(form);
      }
    }
    variantImage(form, option) {
      const card = (form.closest('.nb-card') || this.pickerCard).querySelector('[data-nb-product]');
      const names = JSON.parse(form.dataset.nbOptions || '[]');
      if (names.length < 2 && !names.some(name => /style|colou?r|couleur/i.test(name))) return card.dataset.nbImage;
      if (option?.dataset.nbVariantImage) return option.dataset.nbVariantImage;
      const values = JSON.parse(option?.dataset.nbOptionValues || '[]');
      const styleIndexes = names.map((name, index) => /size|taille|dimension|gr[öo]sse/i.test(name) ? -1 : index).filter(index => index >= 0);
      const sibling = [...form.querySelector('[data-nb-variant]').options].find(candidate => {
        const other = JSON.parse(candidate.dataset.nbOptionValues || '[]');
        return candidate.dataset.nbVariantImage && styleIndexes.every(index => values[index] === other[index]);
      });
      return sibling?.dataset.nbVariantImage || card.dataset.nbImage;
    }
    updateCard(form) {
      const option = form.querySelector('[data-nb-variant]').selectedOptions[0];
      const available = option?.dataset.nbAvailable === 'true';
      const button = form.querySelector('[data-nb-card-add]');
      button.disabled = this.busy || !available;
      button.textContent = available ? this.t('add_to_bundle') : this.t(option ? 'sold_out' : 'unavailable');
      const card = form.closest('.nb-card') || this.pickerCard;
      const cardPrice = card.querySelector('[data-nb-card-price]');
      if (option && cardPrice) cardPrice.textContent = this.money(Number(option.dataset.nbPrice));
      const selectors = [...form.querySelectorAll('[data-nb-option-index]')];
      const values = selectors.map(select => select.value);
      const variants = [...form.querySelector('[data-nb-variant]').options];
      for (const choice of form.querySelectorAll('[data-nb-choice]')) {
        const index = Number(choice.dataset.nbIndex);
        const candidate = variants.find(v => {
          const other = JSON.parse(v.dataset.nbOptionValues || '[]');
          return other.every((value, i) => value === (i === index ? choice.dataset.nbValue : values[i]));
        });
        choice.setAttribute('aria-pressed', String(values[index] === choice.dataset.nbValue));
        choice.classList.toggle('nb-choice-unavailable', !candidate || candidate.dataset.nbAvailable !== 'true');
        if (choice.classList.contains('nb-style-swatch') && !choice.classList.contains('nb-color-swatch')) {
          const source = candidate ? this.variantImage(form, candidate) : '';
          let img = choice.querySelector('img');
          if (source && !img) { img = this.image(source, '', 80); choice.prepend(img); }
          if (source && img) { const url = new URL(source, location.origin); url.searchParams.set('width', '80'); if (img.src !== url.href) img.src = url.href; }
        }
      }
      if (form === this.pickerForm) {
        this.querySelector('[data-nb-picker-price]').textContent = option ? this.money(Number(option.dataset.nbPrice)) : this.t('unavailable');
        const image = this.querySelector('[data-nb-picker-image] img');
        const source = card.dataset.nbPopupImage || card.querySelector('[data-nb-product]').dataset.nbImage;
        if (image && source) { const url = new URL(source, location.origin); url.searchParams.set('width', '1200'); if (image.src !== url.href) image.src = url.href; image.alt = card.querySelector('.nb-card-name').textContent; }
      }
    }
    selectProduct(form) {
      if (this.busy || !form.reportValidity()) return;
      const option = form.querySelector('[data-nb-variant]').selectedOptions[0];
      if (!option || option.dataset.nbAvailable !== 'true' || option.disabled) return;
      const id = Number(option.value), price = Number(option.dataset.nbPrice);
      if (!Number.isSafeInteger(id) || !Number.isInteger(price) || price < 0) return;
      const card = (form.closest('.nb-card') || this.pickerCard).querySelector('[data-nb-product]');
      const title = card.querySelector('.nb-card-name').textContent.trim();
      const properties = Object.fromEntries([...form.querySelectorAll('[data-nb-card-properties] input')].filter(i => i.value.trim()).map(i => [i.name, i.value.trim()]));
      const key = NovaBundleCore.key(id, properties);
      const existing = this.lines.get(key);
      if (existing?.quantity >= this.cfg.maxQuantity || (!existing && this.lines.size >= 100)) { this.message(this.t('quantity_limit'), true); this.querySelector('[data-nb-picker-error]').textContent = this.t('quantity_limit'); return; }
      this.lines.set(key, {id, handle: card.dataset.nbHandle, productId: Number(card.dataset.nbProduct), title, optionValues: JSON.parse(option.dataset.nbOptionValues || '[]'), variant: option.textContent.trim() === 'Default Title' ? '' : option.textContent.trim(), price, image: this.variantImage(form, option), quantity: (existing?.quantity || 0) + 1, properties});
      this.draw();
      this.closePicker();
      this.message(this.t('selected'));
    }
    draw() {
      const lines = [...this.lines.values()];
      const totals = NovaBundleCore.totals(lines, this.tiers);
      const strip = this.querySelector('[data-nb-strip]');
      strip.replaceChildren();
      for (const [key, line] of this.lines) {
        const item = this.el('div', undefined, 'nb-thumb');
        item.dataset.nbKey = key;
        item.append(this.image(line.image, line.title, 120));
        const title = `${line.title} · ${line.variant}`;
        const remove = this.button('×', 'remove', this.t('remove_name', {title}));
        remove.className = 'nb-thumb-remove';
        remove.disabled = this.busy;
        const values = line.optionValues?.length ? line.optionValues : line.variant.split(' / ');
        const label = values.filter(v => v && v !== 'Default Title').map(v => this.optionLabel(v)).join(' · ');
        item.append(remove, this.el('span', label, 'nb-thumb-options'));
        const quantity = this.el('div', undefined, 'nb-thumb-quantity');
        const count = this.el('span', `× ${line.quantity}`);
        count.setAttribute('aria-label', this.t('items', {quantity:line.quantity}));
        quantity.append(count);
        item.append(quantity);
        if (line.quantity <= (this.base.get(key)?.quantity || 0)) item.append(this.el('span', this.cfg.locale.startsWith('fr') ? 'Au panier' : 'In cart', 'nb-thumb-synced'));
        strip.append(item);
      }
      const next = this.tiers.find(t => t.quantity > totals.quantity);
      const placeholder = this.button('', 'browse', next ? this.t('next_tier', {quantity: next.quantity - totals.quantity, percent: next.percent}) : this.t('unlocked', {percent: totals.percent}));
      placeholder.className = 'nb-frame-placeholder';
      placeholder.append(this.el('strong', next ? `+${next.quantity - totals.quantity}` : '+'), this.el('span', this.t('save', {percent: next?.percent || totals.percent})));
      strip.append(placeholder);
      for (const output of this.querySelectorAll('[data-nb-estimate]')) output.textContent = this.money(totals.total);
      this.querySelector('[data-nb-original]').textContent = totals.savings ? this.money(totals.subtotal) : '';
      this.querySelector('[data-nb-add]').disabled = (!lines.length && !NovaBundleCore.changes(this.lines, this.base).size) || this.busy || !this.synced || Boolean(this.pending);
      if (!this.busy) this.querySelector('[data-nb-add]').textContent = this.t('add_to_cart');
      for (const tier of this.querySelectorAll('[data-nb-tier]')) tier.classList.toggle('nb-tier-active', totals.quantity >= Number(tier.dataset.nbTier));
      const counts = new Map();
      for (const line of lines) counts.set(String(line.productId), (counts.get(String(line.productId)) || 0) + line.quantity);
      for (const card of this.querySelectorAll('[data-nb-product]')) {
        const count = counts.get(card.dataset.nbProduct) || 0;
        const badge = card.querySelector('[data-nb-badge]');
        if (badge) { badge.textContent = String(count); badge.hidden = !count; }
      }
      this.querySelector('[data-nb-new]').hidden = !this.pending;
      if (this.pending) this.querySelector('[data-nb-recovery]').hidden = false;
      this.save();
    }
    async search() {
      const q = this.querySelector('[data-nb-search]').value.trim();
      const url = new URL(q ? `${this.root}search` : (this.activeCollectionURL || location.href), location.origin);
      if (q) { url.searchParams.set('q', q); url.searchParams.set('type', 'product'); url.searchParams.set('options[prefix]', 'last'); url.searchParams.set('section_id', 'nova-bundle-search'); }
      else url.searchParams.set('section_id', this.activeCollectionURL ? 'nova-bundle-catalog' : this.cfg.section);
      await this.loadCatalog(url.href, false);
    }
    async loadCatalog(href, append) {
      if (this.cfg.preview) return window.NovaBundlePreview.search(this, append);
      this.searchAbort?.abort();
      const controller = new AbortController(); this.searchAbort = controller;
      this.grid.setAttribute('aria-busy', 'true'); this.next.setAttribute('aria-disabled', 'true');
      try {
        const url = new URL(href, location.origin);
        if (url.origin !== location.origin) throw new Error(this.t('network_error'));
        if (!url.searchParams.has('section_id')) url.searchParams.set('section_id', this.cfg.section);
        const response = await fetch(url, {signal: controller.signal, credentials: 'same-origin'});
        if (!response.ok) throw new Error(this.t('network_error'));
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        if (controller !== this.searchAbort) return;
        const grid = doc.querySelector('[data-nb-grid]');
        if (!grid) throw new Error(this.t('network_error'));
        const cards = [...grid.children].filter(el => !this.activeCollectionId || String(el.dataset.nbCollections || '').split(',').includes(String(this.activeCollectionId)));
        for (const card of cards) {
          const images = JSON.parse(card.dataset.nbImages || '[]');
          const source = images[this.cfg.imageIndex - 1] || images[0];
          const img = card.querySelector('img');
          const link = card.querySelector('[data-nb-product]');
          if (source && img && link) {
            const url = new URL(source, location.origin);
            if (url.protocol !== 'https:' && url.origin !== location.origin) continue;
            url.searchParams.set('width', '700');
            link.dataset.nbImage = url.href;
            img.src = url.href;
            img.srcset = [180,240,360,480,700].map(width => {
              const candidate = new URL(url); candidate.searchParams.set('width', String(width));
              return `${candidate.href} ${width}w`;
            }).join(', ');
          }
        }
        if (!append) this.grid.replaceChildren();
        this.grid.append(...cards);
        this.initCards();
        const next = doc.querySelector('[data-nb-next]');
        if (next?.getAttribute('href')) {
          const nextURL = new URL(next.getAttribute('href'), location.origin);
          nextURL.searchParams.set('section_id', url.searchParams.get('section_id'));
          this.next.href = nextURL.href; this.next.hidden = false;
        } else { this.next.removeAttribute('href'); this.next.hidden = true; }
        this.querySelector('[data-nb-no-results]').hidden = Boolean(this.grid.children.length);
        this.draw();
        this.message(this.t('results', {quantity: this.grid.children.length}));
      } catch (error) { if (error.name !== 'AbortError') this.message(this.t('load_error'), true); }
      finally { if (controller === this.searchAbort) { this.grid.removeAttribute('aria-busy'); this.next.removeAttribute('aria-disabled'); } }
    }
    async validateSelection() {
      let changed = false;
      const products = new Map();
      const handles = [...new Set([...this.lines.values()].map(l => l.handle))];
      for (let i = 0; i < handles.length; i += 4) {
        await Promise.all(handles.slice(i, i + 4).map(async handle => products.set(handle, await this.product(handle, true))));
      }
      for (const line of this.lines.values()) {
        const variant = products.get(line.handle).variants.find(v => v.id === line.id);
        if (!variant?.available) throw new Error(this.t('stock_error', {title: line.title}));
        if (variant.price !== line.price) { line.price = variant.price; changed = true; }
      }
      if (changed) { this.draw(); throw new Error(this.t('price_changed')); }
    }
    async renderCart(data, notice = '') {
      if (this.cfg.preview) return window.NovaBundlePreview.renderCart(data);
      if (window.NovaCart?.open) { await window.NovaCart.open(data, notice); return; }
      if (typeof window.opusOpen === 'function' && typeof window.opusRefreshCart === 'function') {
        await window.opusRefreshCart();
        window.opusOpen();
        return;
      }
      const component = document.querySelector('cart-items');
      const drawer = document.querySelector('cart-drawer');
      if (!component || !drawer || typeof component.build !== 'function') { location.assign(`${this.root}cart`); return; }
      let html = data.sections?.['api-cart-items'];
      if (!html) {
        const response = await fetch(`${this.root}cart?section_id=api-cart-items`, {credentials: 'same-origin', signal: AbortSignal.timeout(15000)});
        if (!response.ok) throw new Error(this.t('cart_render_error'));
        html = await response.text();
      }
      const fragment = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-api-content]');
      if (!fragment) throw new Error(this.t('cart_render_error'));
      component.build(fragment);
      drawer.querySelector('[data-nova-bundle-notice]')?.remove();
      if (notice) {
        const output = this.el('p', notice, 'nb-message nb-error');
        output.dataset.novaBundleNotice = '';
        output.setAttribute('role', 'status');
        output.style.padding = '12px 20px';
        (drawer.querySelector('[data-cart-drawer-inner]') || drawer).prepend(output);
      }
      drawer.dispatchEvent(new CustomEvent('theme:cart-drawer:show'));
    }
    async addBundle() {
      if (this.busy || this.pending || !this.synced) return;
      this.busy = true;
      this.closePicker();
      this.draw();
      this.querySelector('[data-nb-add]').textContent = this.t('adding');
      this.message('');
      const run = async () => {
        await this.refreshCart();
        const desired = new Map([...this.lines].map(([key,line]) => [key,{...line}]));
        const {additions, updates} = NovaBundleCore.plan(desired, this.base);
        let response = {}, notice = '', posted = false;
        try {
          if (Object.keys(updates).length) response = await this.request(`${this.root}cart/update.js`, {method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({updates, sections:['api-cart-items','nova-bundle-cart'], sections_url:`${this.root}cart`})});
          if (additions.length) {
            const operation = crypto.randomUUID();
            const items = additions;
            const targets = additions.map(item => ({...desired.get(NovaBundleCore.key(item.id,item.properties))}));
            this.pending = {mode:'quantity', operation, items:additions, targets}; this.save();
            posted = true;
            try {
              response = await this.request(`${this.root}cart/add.js`, {method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({items, sections:['api-cart-items','nova-bundle-cart'], sections_url:`${this.root}cart`})});
              this.pending = null;
            } catch (error) {
              const check = await this.cartSnapshot();
              const status = NovaBundleCore.reconcileTargets(check.cart, targets);
              if (status === 'complete') this.pending = null;
              else if (error.status >= 400 && error.status < 500) { this.pending = null; throw error; }
              else throw new Error(this.t('uncertain'));
            }
          }
          const code = this.querySelector('[data-nb-code]')?.value.trim() || '';
          if (code) {
            try {
              const cart = await this.request(`${this.root}cart.js`);
              const codes = NovaBundleCore.codes((cart.discount_codes || []).map(c => c.code), code);
              if (codes.length > 5) throw new Error(this.t('code_limit'));
              response = await this.request(`${this.root}cart/update.js`, {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({discount:codes.join(','),sections:['api-cart-items','nova-bundle-cart'],sections_url:`${this.root}cart`})});
              if (code.split(',').some(c => !response.discount_codes?.some(d => d.code.toLowerCase() === c.trim().toLowerCase() && d.applicable))) notice = this.t('code_failed');
            } catch { notice = this.t('code_failed'); }
          }
          const changed = additions.length || Object.keys(updates).length || code;
          this.applyCart(this.cartFromSections(response) || (changed ? await this.cartSnapshot() : this.snapshot), new Map());
          this.save();
          await this.renderCart(response, notice);
          this.message(notice || this.t('added'), Boolean(notice));
        } catch (error) {
          try {
            const snapshot = await this.cartSnapshot();
            this.applyCart(snapshot, new Map());
            this.lines = desired;
          } catch { if (posted) this.synced = false; }
          this.message(error.message, true);
        }
      };
      try { if (navigator.locks) await navigator.locks.request('nova-bundle-cart', run); else await run(); }
      catch (error) { this.message(error.message, true); }
      finally { this.busy = false; this.draw(); }
    }

  }
  customElements.define('nova-bundle-builder', NovaBundleBuilder);
})();


  } catch(e) { console.error(e); }
})();
})();
